<template>
  <div>
    <div class="search-box">
      <span class="iconfont home mr5 ml5 cursor" v-if="isHasHome" @click="to"
        ><img src="../../assets/image/material/back.png"
      /></span>

      <!-- <el-input
        size="small"
        class="search-input"
        :placeholder="placeholder"
        prefix-icon="el-icon-search"
        v-model="keyword"
        @keyup.enter.native="search"
        :fetch-suggestions="querySearch"
      ></el-input> -->
      <el-autocomplete
        size="small"
        class="search-input"
        :placeholder="placeholder"
        prefix-icon="el-icon-search"
        v-model="keyword"
        @keyup.enter.native="search"
        :fetch-suggestions="querySearch"
        @select="select"
        ref="searchkeyword"
        id="searchkeyword"
      >
        <i
          v-if="isShowClearKeyword"
          class="el-icon-close el-input__icon"
          slot="suffix"
          @click="clearkeyword"
        >
        </i>
      </el-autocomplete>
      <el-button
        class="search-button"
        size="small"
        @click="search"
        ref="searchbutton"
        >搜索</el-button
      >

      <!-- <el-autocomplete
      class="inline-input"
      v-model="state1"
      :fetch-suggestions="querySearch"
      placeholder="请输入内容"
      @select="handleSelect"
    ></el-autocomplete> -->
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
export default {
  props: ["isHasHome", "placeholder", "isShowHistory", "isShowClearKeyword"],
  data() {
    return {
      keyword: this.$route.params.keyword

      //history:[{ value: "aaa" }, { value: "bbb" }];
    };
  },
  watch: {
    $route(to) {
      this.keyword = to.params.keyword;
    }
  },
  computed: {},
  methods: {
    search() {
      if (this.keyword && this.isShowHistory) {
        this.setHistory(this.keyword);
      }

      this.$emit("search", this.keyword);
      this.$refs.searchkeyword.activated = false;

      var input = document.getElementById("searchkeyword");
      input.blur();
    },
    to() {
      this.$router.go(-1);
      // this.$router.push(url);
    },
    querySearch(queryString, cb) {
      if (this.isShowHistory) {
        var history = JSON.parse(localStorage.getItem("searchHistory") || "[]");
        if (history.length > 0) {
          history = history.slice(0, 10);
          localStorage.setItem("searchHistory", JSON.stringify(history));
        }
        cb(history);
      } else {
        cb([]);
      }
    },
    setHistory(keyword) {
      let history = JSON.parse(localStorage.getItem("searchHistory") || "[]");
      if (history.filter(m => m.value === keyword).length > 0) {
        for (let i = 0; i < history.length; i++) {
          if (history[i].value === keyword) {
            history.splice(i, 1);
          }
        }
      }
      history.unshift({ value: keyword });
      localStorage.setItem("searchHistory", JSON.stringify(history));
    },
    select(item) {
      this.$emit("search", item.value);
    },
    clearkeyword() {
      this.keyword = "";
    }
  },
  mounted() {
    this.keyword = this.$route.params.keyword;
  },
  activated() {
    this.keyword = this.$route.params.keyword;
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.search-box {
  display: flex;
  // width: 480px;
  height: 32px;
  .search-button {
    background-color: #99b4eb;
    color: #eff4f5;
    border-radius: 0 16px 16px 0;
    border: none;
    // width: 100px;
    // flex: 1;
    flex: 1;
  }
  .search-input {
    flex: 22;
  }

  .home {
    width: 35px;
    height: 35px;
    line-height: 35px;
    background-color: #eff3ff;
    text-align: center;
    border-radius: 50%;
  }
}

/deep/.el-input__inner {
  border: none;
  background-color: #eff3ff;
  border-radius: 16px 0 0 16px;
  font-size: 14px;
  color: #333;
  height: 32px;
  line-height: 32px;
  flex: 8;
}
/deep/.el-input__inner::placeholder {
  color: #94a9ca;
}
// /deep/.el-input--mini .el-input__icon {
//   color: red;
// }
/deep/.el-icon-close {
  cursor: pointer;
}
/deep/.el-input__prefix {
  top: 2px;
}
/deep/.el-button--small {
  font-size: 13px;
}
</style>
